<template>
    <fragment>
        <div
            class="text-2xl uppercase font-bold mb-4"
            v-html="title"
        />
        <div
            v-if="subtitle"
            class="text-sm text-center lg:hidden cz2__panel-header__sub-title"
            v-html="subtitle"
        />
        <div
            v-if="body"
            class="hidden sm:!block text-2xl uppercase font-bold"
            :class="{
                'mb-4': bodySubtitle == null,
            }"
            v-html="body"
        />
        <div
            v-if="bodySubtitle"
            class="hidden sm:!block text-sm uppercase mb-4 text-gray-300"
            v-html="bodySubtitle"
        />
    </fragment>
</template>

<script>
    import { Fragment } from 'vue-frag';

    export default {
        components: {
            Fragment,
        },
        props: {
            title: String,
            subtitle: {
                type: String,
                default: null,
            },
            body: String,
            bodySubtitle: String,
        },
    };
</script>
